export const highlightRowBasedOnId = (id?: string): void => {
  const elements = Array.from(document.querySelectorAll('tr'))

  if (elements?.length) {
    elements.forEach(el => {
      el.style.removeProperty('background-color')
    })
  }

  if (!id) return

  const element = document.getElementById(id)

  if (element) {
    const parentWithClass = element.closest('tr')
    if (parentWithClass) {
      // Use inline style with !important to guarantee override
      parentWithClass.style.setProperty(
        'background-color',
        'var(--surface-interactive-hover)',
        'important'
      )
    }
  }
}
